import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import * as API from 'services/api';
import DataTable from 'components/PageBase/dataTable';
import { PERPAGE } from 'config';
import { columnCreatedAt, columnId } from 'pages/common';

const CertificateVerificationTab = ({ intl: { formatMessage } }) => {
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageState, setPageState] = useState(1);
    const [total, setTotal] = useState(0);
    const [allLoaded, setAllLoaded] = useState(false);
    const [keyword, setKeyword] = useState('');
    const [openFilter, setOpenFilter] = useState(false);

    const loadRecords = (pageToLoad = 1) => {
        setLoading(true);
        API.listCertificateVerificationRequests({
            page: pageToLoad,
            perPage: PERPAGE,
            ...(keyword && keyword.trim() ? { keyword: keyword.trim() } : {}),
        })
            .then(res => {
                if (res.code === 200 || res.code === 206) {
                    setRecords(res.data || []);
                    setTotal(res.total || (res.data || []).length);
                    setPageState(pageToLoad);
                    setAllLoaded(res.code === 200);
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));
    };

    useEffect(() => {
        loadRecords(1);
    }, [keyword]);

    const handlePageChange = (newPage) => {
        if (newPage === pageState) return;
        loadRecords(newPage);
    };

    const tableColumns = [
        columnId(formatMessage),
        {
            name: 'firstName',
            label: formatMessage({ id: 'certificateVerificationRequest.field.firstName' }),
            options: { filter: false, sort: true },
        },
        {
            name: 'lastName',
            label: formatMessage({ id: 'certificateVerificationRequest.field.lastName' }),
            options: { filter: false, sort: true },
        },
        {
            name: 'email',
            label: formatMessage({ id: 'certificateVerificationRequest.field.email' }),
            options: { filter: false, sort: true },
        },
        {
            name: 'noCases',
            label: formatMessage({ id: 'certificateVerificationRequest.field.noCases' }),
            options: { filter: false, sort: true },
        },
        {
            name: 'type',
            label: formatMessage({ id: 'certificateVerificationRequest.field.type' }),
            options: {
                filter: false,
                sort: true,
                customBodyRender: (value) => {
                    if (!value) return '';
                    const typeLabels = {
                        'france-chimie': formatMessage({ id: 'certificateVerificationRequest.type.france-chimie' }),
                        caces: formatMessage({ id: 'certificateVerificationRequest.type.caces' }),
                    };
                    return typeLabels[value] || value;
                },
            },
        },
        {
            name: 'accessedAt',
            label: formatMessage({ id: 'certificateVerificationRequest.field.accessedAt' }),
            options: { filter: false, sort: true },
        },
        columnCreatedAt(formatMessage),
    ];

    return (
        <DataTable
            dataLoading={loading}
            openFilter={openFilter}
            setOpenFilter={setOpenFilter}
            setFilters={() => {}}
            keyword={keyword}
            setKeyword={setKeyword}
            allUsersLoaded={allLoaded}
            pagination={{ page: pageState, perPage: PERPAGE, total, onChange: handlePageChange }}
            tableColumns={tableColumns}
            datasource={records}
            data={records}
        />
    );
};

CertificateVerificationTab.propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired,
    }),
};

export default injectIntl(CertificateVerificationTab);
